import Image, { type ImageProps } from "next/image";

import { PRODUCT_LOGO_SRC } from "@/lib/branding/product-logo";
import { cn } from "@/lib/utils";

type ProductLogoProps = Omit<ImageProps, "src" | "alt"> & {
  alt?: string;
};

/** Product mark — preserves container size; use `object-contain` visual weight. */
export function ProductLogo({
  alt = "Inora",
  className,
  priority = false,
  loading,
  ...props
}: ProductLogoProps) {
  return (
    <Image
      src={PRODUCT_LOGO_SRC}
      alt={alt}
      draggable={false}
      className={cn("object-contain", className)}
      {...props}
      priority={priority}
      loading={priority ? "eager" : (loading ?? "lazy")}
    />
  );
}
